module.exports = __webpack_public_path__ + "img/P31-en.3da82456.png";